var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#22BFBF"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006C70"
    },
    d: "M263.913,511.867c124.404-3.779,226.482-96.303,245.06-216.421L350.241,135.613l-22.123,2.874 l-51.143,12.067l20.771,20.771l-39.927,27.162l-27.014-26.608l-85.316,37.421l-15.977,6.716l51.467,51.04l-66.994,32.88 l4.039,65.584L263.913,511.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD300"
    },
    d: "M163.556,384.431c-35.526,0-64.431-28.905-64.431-64.431s28.905-64.431,64.431-64.431 s64.431,28.905,64.431,64.431S199.084,384.431,163.556,384.431z M163.556,284.875c-19.366,0-35.125,15.758-35.125,35.125 c0,19.366,15.758,35.125,35.125,35.125S198.68,339.366,198.68,320C198.68,300.634,182.924,284.875,163.556,284.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A200"
    },
    d: "M163.556,255.569c-0.217,0-0.429,0.014-0.646,0.017v29.324c0.217-0.003,0.428-0.033,0.646-0.033 c19.366,0,35.125,15.758,35.125,35.125c0,19.366-15.757,35.123-35.125,35.123c-0.217,0-0.429-0.029-0.646-0.033v29.324 c0.215,0.002,0.429,0.017,0.646,0.017c35.526,0,64.431-28.905,64.431-64.431S199.084,255.569,163.556,255.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD300"
    },
    d: "M344.89,384.431c-49.25,0-89.321-40.069-89.321-89.321s40.069-89.321,89.321-89.321 s89.321,40.069,89.321,89.321S394.14,384.431,344.89,384.431z M344.89,235.098c-33.09,0-60.014,26.922-60.014,60.014 s26.924,60.013,60.014,60.013s60.014-26.922,60.014-60.014S377.98,235.098,344.89,235.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A200"
    },
    d: "M434.209,295.112c0-48.999-39.662-88.891-88.566-89.3v29.306 c32.742,0.407,59.259,27.157,59.259,59.994s-26.515,59.587-59.259,59.994v29.306C394.547,384.003,434.209,344.109,434.209,295.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F3FF"
    },
    d: "M341.333,131.017h-56.889c-6.189,0-11.205,5.017-11.205,11.205c0,6.189,5.017,11.205,11.205,11.205 h45.684v6.84c-14.429,1.557-41.281,6.11-70.282,19.389c-19.966,9.142-42.861,23.459-62.923,45.633l-19.391-30.47 c-3.322-5.223-10.252-6.761-15.469-3.437c-5.222,3.322-6.761,10.247-3.437,15.469l23.571,37.04 c-12.917,18.691-23.68,41.662-30.206,69.925c-1.393,6.03,2.367,12.047,8.395,13.44c0.848,0.197,1.696,0.29,2.532,0.29 c5.099,0,9.712-3.505,10.907-8.685c12.816-55.489,44.646-95.354,94.615-118.486c24.836-11.498,48.319-15.867,61.687-17.515v101.585 c0,6.189,5.017,11.205,11.205,11.205s11.205-5.017,11.205-11.205V142.222C352.539,136.033,347.522,131.017,341.333,131.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDBE6"
    },
    d: "M341.333,131.017h-56.889c-6.189,0-11.205,5.017-11.205,11.205c0,6.189,5.017,11.205,11.205,11.205 h45.684v6.84c-14.002,1.51-39.703,5.866-67.71,18.253l17.136,17.136c20.573-8.021,39.224-11.4,50.574-12.8v101.588 c0,6.189,5.017,11.205,11.205,11.205s11.205-5.017,11.205-11.205V142.222C352.539,136.033,347.522,131.017,341.333,131.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M233.877,177.923c-0.881-5.423-5.566-9.411-11.061-9.411h-60.912 c-19.646,0-35.628,15.982-35.628,35.628v4.022c0,3.603,1.731,6.985,4.653,9.09c1.932,1.393,4.23,2.115,6.553,2.115 c1.189,0,2.386-0.188,3.544-0.576l85.333-28.444C231.574,188.609,234.756,183.346,233.877,177.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M233.877,177.923c-0.881-5.423-5.566-9.411-11.061-9.411h-60.164l20.221,36.33l43.486-14.495 C231.574,188.609,234.756,183.346,233.877,177.923z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.6788f601f28a2cb15409500506382830.svg";
export { ForwardRef as ReactComponent };